import type { GetSessionResponse } from '@/domains/auth/api/session/session.types';
import type { IUser } from '@/domains/auth/common/types';
import posthog from 'posthog-js';

import { request } from '@/lib/request';

export async function fetchSession(): Promise<IUser | null> {
  const result = await request.get<GetSessionResponse>('auth/session');

  if (result.data.user) {
    try {
      posthog.identify(result.data.user.id, {
        email: result.data.user.email,
        name: result.data.user.firstName + ' ' + result.data.user.lastName,
      });
    } catch (error) {
      console.error('Error identifying user in PostHog:', error);
    }
  }

  return result.data.user ? result.data.user : null;
}
